import { atom } from "recoil";

export const shsgCourseRatingsState = atom({
  key: "shsgCourseRatingsState",
  default: null,
});
